const SUPER_DEFAULT_LOCALE = 'sv_SE';
const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE || SUPER_DEFAULT_LOCALE;

export const CONSTANTS = {
    DEFAULT: DEFAULT_LOCALE,
    ENABLED_LOCALES: (process.env.REACT_APP_ENABLED_LOCALES || DEFAULT_LOCALE).toLowerCase().split(','),
};
